import { Platform, Events, LoadingController, AlertController } from 'ionic-angular';
import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { GlobalvariablesProvider } from '../../providers/globalvariables/globalvariables';
import * as CryptoJS from 'crypto-js';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/timeout';
import { timeout, catchError } from "rxjs/operators";
import { FileTransfer, FileTransferObject } from '@ionic-native/file-transfer';
import { Device } from '@ionic-native/device';

declare var window;

@Injectable()
export class GatewayClientProvider {
  sql_db = null;
  savingsaccounts: any = [];
  currentaccounts: any;
  savingstransactions: any = {};
  mortgageaccounts: any = [];
  mortgagetransactions: any = {};
  products: any = [];
  members: any = [];
  flag: any = 1;
  messages: any = [];
  faqs: any = [];
  labels: any = [];
  resultdata: any = [];
  branches: any = [];
  goals: any = [];
  cheques: any = [];
  sweeper: any = [];
  directdebits: any = [];
  smartsaver: any = [];
  loading: any;
  smartsaver_transaction: any = [];
  connection_transactions: any = [];
  regularsavings: any = [];
  ready: boolean = false;
  loader: any;
  settings: any;
  token: any = null;
  verifier_code = null;
  code_challenge = null;
  toauth2Host = null;
  oauth2Port = null;
  renewBeforeMilliseconds = 100;
  code = null;
  state = null;
  expires_in = null;
  expires = null;
  refresh_token: any;
  refreshTokenExpiry: any;
  refresh_token_expires_in = null;
  refresh_token_expires = null;
  paycasso_session: any = null;
  paycasso_token: string = "";
  paycasso_transaction_id: string = "";
  private requestQueue: Promise<any> = Promise.resolve();
  constructor(
    public events: Events,
    public http: Http,
    public alertCtrl: AlertController,
    private global: GlobalvariablesProvider,
    private transfer: FileTransfer,
    public loadingCtrl: LoadingController,
    public platform: Platform,
    public device: Device
  ) {
    this.events.subscribe("authtoken", (authtokenString) => {


    });

  }

  loadData() {
    let self = this;


    return Promise.all([
      new Promise(function (resolve, reject) {
        self.http.get('assets/data/sweeper.json')
          .map((res) => res.json())
          .subscribe(
            (data) => {

              self.sweeper = data;
              resolve(data);
            },
            (err) => {
              // console.error("Could not load transactions: " + err);
              reject(err);
            });
      }),
      // new Promise(function (resolve, reject) {
      //   self.http.get('assets/data/saver.json')
      //     .map((res) => res.json())
      //     .subscribe(
      //       (data) => {
      //         
      //         self.connection_transactions = data.connection_transactions;
      //         resolve(true);
      //       },
      //       (err) => {
      //         console.error("Could not load Smart Saver: " + err);
      //         reject(err);
      //       });
      // }),
      // new Promise(function (resolve, reject) {
      //   self.http.get('assets/data/languages.json')
      //     .map((res) => res.json())
      //     .subscribe(
      //       (data) => {
      //         self.labels = data;
      //         
      //         resolve(true);
      //       },
      //       (err) => {
      //         reject(err);
      //       });
      // })
    ])

  }

  /**
   * Oauth api for authorization
   * @param url 
   * @param body 
   */
  oauth_post(url, body) {
    let self = this;
    let is_secure = false;
    let applive_ssl_fingerprint = "1A 30 EC 13 22 BE 5D DC 28 6F 5E 0B FE 30 DE 9A B7 F9 7C D7 5E 7A AD 05 5F 27 BF 1B 5C E8 FF 49";
    let apptest_ssl_fingerprint = "95 90 A9 81 75 9E 40 22 57 5C 9D 3E 26 DB 32 B5 5B F3 54 82 A7 15 17 60 31 33 D9 F2 BE 7C 59 FF";
    let sslMessage = "";
    // window.plugins.sslCertificateChecker.check(
    //   successCallback,
    //   errorCallback,
    //   self.global.getBaseUrl() + url,
    //   applive_ssl_fingerprint);

    // function successCallback(message) {
    //   is_secure = true;
    //   sslMessage = message
    //   window.hideConnectionNotSecure();
    //   window.hideSlowNet();
    // }

    // function errorCallback(message) {
    //   is_secure = false;
    //   setTimeout(function () {
    //     if (window.sslSecure == false) {
    //       if (message == "CONNECTION_NOT_SECURE") {

    //         sslMessage = message;
    //         //window.showConnectionNotSecure();
    //       } else if (message.indexOf("CONNECTION_FAILED") > - 1) {

    //         sslMessage = "CONNECTION_FAILED";
    //         window.slowNetError();
    //       }
    //     }
    //   }, 4000);

    // }
    return new Promise(function (resolve, reject) {
      let headers = new Headers();
      //headers.append('Content-Type', 'application/x-www-form-urlencoded');
      if (url === "/oauth2/refreshtoken") {
        headers.append('Authorization', 'Bearer ' + self.token);
        headers.append('Content-Type', 'application/json');
      }
      else {
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
      }
      headers.append('Access-Control-Allow-Origin', self.global.getBaseUrl());
      headers.append('Origin', self.global.getBaseUrl());

      self.http.post(self.global.getBaseUrl() + url, body, { headers: headers })
        .map(res => res.json())
        .pipe(
          timeout(self.global.ajaxTimeout),
          catchError(e => {
            // do something on a timeout
            // 
            // 
            // return of(null);
            throw e;
          })
        )
        .subscribe(data => {
          if (data) resolve(data);
          else {

            self.events.publish("consectus:oauth.fail", "Network slow");
            reject("Network timedout");
          }
        }, error => {
          if (error.name !== undefined && error.name === "TimeoutError" || error.status === 0) {
            self.events.publish("consectus:oauth.fail", "Network timeout error occurred");
          } else {
            if (error.status == 404) {
              self.events.publish("consectus:404.error", error);
            } else if (error.status == 401) {
              self.events.publish("consectus:500.error", error);
            } else if (error.status == 403) {
              console.log(error);
              window.location.href = "/";
            } else if (error.status == 500 || error.status == 400) {
              self.events.publish("consectus:500.error", error);
            } else if (error.status == 503) {
              window.show401(error.error);
            } else if (error.status !== 0) {
              self.events.publish("consectus:network.error", error);
            } else {
              console.log(error);
            }
          }
          reject(error);
        });
    });
  }

  /**
   * Common api for all get method 
   * @param url 
   */
  call_get(url, showLoading = false, attempt: number = 1, useQueue: boolean = true) {
    let self = this;
    const callAction = () => {
      if (showLoading) self.showLoading();
      return new Promise(function (resolve, reject) {
        let headers = new Headers();
        headers.append('Access-Control-Allow-Origin', self.global.getBaseUrl());
        headers.append('Origin', self.global.getBaseUrl());
        headers.append('Authorization', 'Bearer ' + self.token);
        self.http.get(self.global.getBaseUrl() + url, { headers: headers })
          .map(res => res.json())
          .pipe(
            timeout(self.global.ajaxTimeout),
            catchError(e => {
              throw e;
            })
          )
          .subscribe(data => {
            self.hideLoading();
            if (data) resolve(data);
            else reject("Network timedout");
          }, async (error) => {
            if (error.status === 401 && attempt <= 2) {
              try {
                await self.refreshToken();
                const retry = await self.call_get(url, showLoading, attempt + 1, false);
                resolve(retry);
              } catch (e) {
                window.location.href = "/";
                reject(e);
              }
            } else {
              if (error.name !== undefined && error.name == "TimeoutError" || error.status === 0) {
                self.events.publish("consectus:network.slow", "Network timeout error occurred");
                self.hideLoading();
              } else {
                if (error.status == 404) {
                  self.events.publish("consectus:404.error", error);
                } else if (error.status == 500 || error.status == 400) {
                  self.events.publish("consectus:500.error", error);
                } else if (error.status === 503) {
                  window.show401(JSON.parse(error._body));
                } else if (error.status !== 0) {
                  self.events.publish("consectus:network.error", error);
                } else {
                  console.log(error);
                }
                self.hideLoading();
              }
              reject(error);
            }
          });
      });
    };
    return useQueue ? self.enqueueRequest(callAction) : callAction();
  }

  /**
   * get api for address in new account opening
   * @param url 
   */
  get_address(body, showLoading = false) {

    let self = this;
    let url = '/proxy/address/search';
    return new Promise((resolve, reject) => {
      self.call_post(url, body)
        .then((accountrules) => {
          resolve(accountrules);
        }).catch((err) => {
          reject(err);
        })
    });
    // if (showLoading) self.showLoading();
    // return new Promise(function (resolve, reject) {
    //   let headers = new Headers();
    //   headers.append('Auth-Token', '8916dc2e-39ea-46de-911b-ebb361ee9c4b');
    //   self.http.get("https://api.experianmarketingservices.com/capture/v1/search-address/text/?query=" + url + "&country=GBR", { headers: headers })
    //     .map(res => res.json())
    //     .pipe(
    //       timeout(self.global.ajaxTimeout),
    //       catchError(e => {
    //         throw e;
    //       })
    //     )
    //     .subscribe(data => {
    //       self.hideLoading();
    //       if (data) resolve(data);
    //       else reject("Network timedout");
    //     }, error => {
    //       if (error.name !== undefined && error.name == "TimeoutError" || error.status === 0) {
    //         self.events.publish("consectus:network.slow", "Network timeout error occurred");
    //         self.hideLoading();
    //       } else {
    //         if (error.status == 404) {
    //           self.events.publish("consectus:404.error", error);
    //         }
    //         else if (error.status == 401) {
    //           self.events.publish("consectus:500.error", error);
    //         }
    //         else if (error.status == 500 || error.status == 400) {
    //           self.events.publish("consectus:500.error", error);
    //         }
    //         else if (error.status !== 0) {
    //           self.events.publish("consectus:network.error", error);
    //         }
    //         self.hideLoading();
    //       }
    //       reject(error);
    //     });
    // });
  }

  /**
   * get api for address in new account opening
   * @param url 
   */
  get_addressLines(body, showLoading = false) {
    let self = this;
    let url = '/proxy/address/layout';
    return new Promise((resolve, reject) => {
      self.call_post(url, body)
        .then((accountrules) => {
          resolve(accountrules);
        }).catch((err) => {
          reject(err);
        })
    });
    // if (showLoading) self.showLoading();
    // return new Promise(function (resolve, reject) {

    //   let headers = new Headers();
    //   // headers.append('Access-Control-Allow-Origin', '*'),
    //   // headers.append('Access-Control-Allow-Methods', 'POST, GET, PUT, DELETE'),
    //   // headers.append('Content-Type', 'application/json'),
    //   headers.append('Auth-Token', '8916dc2e-39ea-46de-911b-ebb361ee9c4b');
    //   self.http.get("https://api.experianmarketingservices.com/capture/v1/address-layout/" + addressUrl + "/", { headers: headers })
    //     .map(res => res.json())
    //     .pipe(
    //       timeout(self.global.ajaxTimeout),
    //       catchError(e => {
    //         // do something on a timeout

    //         // 
    //         // return of(null);
    //         throw e;
    //       })
    //     )
    //     .subscribe(data => {
    //       self.hideLoading();


    //       if (data) resolve(data);
    //       else reject("Network timedout");
    //     }, error => {
    //       if (error.name !== undefined && error.name == "TimeoutError" || error.status === 0) {
    //         self.events.publish("consectus:network.slow", "Network timeout error occurred");
    //         self.hideLoading();
    //       } else {
    //         if (error.status == 404) {
    //           //self.events.publish("consectus:404.error", error);
    //         }
    //         else if (error.status == 401) {
    //           //self.events.publish("consectus:500.error", error);
    //         }
    //         else if (error.status == 500 || error.status == 400) {
    //           //self.events.publish("consectus:500.error", error);
    //         }
    //         else if (error.status !== 0) {
    //           //self.events.publish("consectus:network.error", error);
    //         }
    //         self.hideLoading();
    //       }
    //       reject(error);
    //     });

    // });
  }

  /**
  * Common api for all post method 
  * @param url 
  */
  call_post(url, body, showLoading = false, token = false, attempt: number = 1, useQueue: boolean = true, bubbleError: boolean = false) {
    let self = this;
    const callAction = () => {
      if (showLoading) self.showLoading();
      return new Promise(function (resolve, reject) {
        const headers = new Headers();
        headers.append('Access-Control-Allow-Origin', self.global.getBaseUrl());
        headers.append('Origin', self.global.getBaseUrl());
        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + self.token);
        self.http.post(self.global.getBaseUrl() + url, body, { headers: headers })
          .map(res => res.json())
          .pipe(
            timeout(self.global.ajaxTimeout),
            catchError(e => {
              throw e;
            })
          )
          .subscribe(data => {
            self.hideLoading();
            if (data) resolve(data);
            else reject("Network timedout");
          }, async (error) => {
            if (error.status === 401 && attempt <= 2) {
              try {
                await self.refreshToken();
                const retry = await self.call_post(url, body, showLoading, token, attempt + 1, false, bubbleError);
                resolve(retry);
              } catch (e) {
                window.location.href = "/";
                reject(e);
              }
            } else if (bubbleError) {
              // Caller opted to handle the error itself: skip global error events
              // (e.g. consectus:500.error screen) and reject straight to parent.
              self.hideLoading();
              reject(error);
            } else {
              if (error.name !== undefined && error.name == "TimeoutError" || error.status === 0) {
                self.events.publish("consectus:network.slow", "Network timeout error occurred");
                self.hideLoading();
              } else {
                if (error.status == 404) {
                  self.events.publish("consectus:404.error", error);
                } else if (error.status == 500 || error.status == 400) {
                  self.events.publish("consectus:500.error", error);
                } else if (error.status === 503) {
                  window.show401(JSON.parse(error._body));
                } else if (error.status !== 0) {
                  self.events.publish("consectus:network.error", error);
                } else {
                  console.log(error);
                }
                self.hideLoading();
              }
              reject(error);
            }
          });
      });
    }

    return useQueue ? self.enqueueRequest(callAction) : callAction();
  }

  /**
   * Common api for upload image
   * @param url 
   */
  upload_image(url, formData) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.getAccessToken().then((tokenData: any) => {
        let headers = new Headers();
        //headers.append('Access-Control-Allow-Origin', '*'),
        // headers.append('Access-Control-Allow-Methods', 'POST, GET, PUT, DELETE'),
        headers.append('Access-Control-Allow-Origin', self.global.getBaseUrl());
        headers.append('Origin', self.global.getBaseUrl());
        headers.append('enctype', 'multipart/form-data');
        headers.append('Authorization', "Bearer " + self.token);
        self.showLoading();
        self.http.post(self.global.getBaseUrl() + url, formData, { headers: headers })
          .map(res => res.json())
          .pipe(
            timeout(self.global.ajaxTimeout),
            catchError(e => {
              // do something on a timeout

              // 
              // return of(null);
              throw e;
            })
          )
          .subscribe(data => {
            self.hideLoading();
            if (data) resolve(data);
            else reject("Network timedout");
          }, error => {
            if (error.name !== undefined && error.name == "TimeoutError" || error.status === 0) {
              self.events.publish("consectus:network.slow", "Network timeout error occurred");
              self.hideLoading();
            } else {
              if (error.status == 404) {
                self.events.publish("consectus:404.error", error);
              }
              else if (error.status == 401) {
                self.events.publish("consectus:401.error", error);
              }
              else if (error.status == 500 || error.status == 400) {
                self.events.publish("consectus:500.error", error);
              }
              else if (error.status !== 0) {
                self.events.publish("consectus:network.error", error);
              }
            }
            reject(error);
          });
      }).catch((err) => {
        reject(err);
      })

    });
  }
  /**
   * Upload Image from camera plugin 
   * @param sourceUrl : source url come from the 
   */
  uploadImage(sourceUrl) {
    // Destination URL
    let self = this;
    let url = "/accounts/uploadtempfile";
    let name = sourceUrl.substr(sourceUrl.lastIndexOf('/') + 1);

    self.showLoading();
    return new Promise(function (resolve, reject) {
      // File name only
      let options = {
        fileKey: "file-to-upload",
        fileName: name,
        chunkedMode: false,
        httpMethod: 'POST',
        mimeType: "multipart/form-data",
        headers: {
          'Authorization': "Bearer " + self.token
        }
      };
      const fileTransfer: FileTransferObject = self.transfer.create();

      // Use the FileTransfer to upload the image
      fileTransfer.upload(sourceUrl, encodeURI(self.global.getBaseUrl() + url), options).then(data => {

        self.hideLoading();
        resolve(data);
      }, err => {

        self.hideLoading();
        reject(err);
      });
    });
  }

  /**
  * Common api for all put method 
  * @param url 
  */
  // call_put(url, body, showLoading = false) {
  //   let self = this;
  //   if (showLoading) self.showLoading();
  //   return new Promise(function (resolve, reject) {
  //     self.getAccessToken().then((tokenData: any) => {
  //       let headers = new Headers();
  //       // headers.append('Access-Control-Allow-Origin', '*'),
  //       //   headers.append('Access-Control-Allow-Methods', 'POST, GET, PUT, DELETE'),
  //       headers.append('Access-Control-Allow-Origin', self.global.getBaseUrl());
  //       headers.append('Origin', self.global.getBaseUrl());
  //       headers.append('Content-Type', 'application/json');
  //       headers.append('Authorization', "Bearer " + self.token);
  //       self.http.put(self.global.getBaseUrl() + url, body, { headers: headers })
  //         .map(res => res.json())
  //         .pipe(
  //           timeout(self.global.ajaxTimeout),
  //           catchError(e => {
  //             // do something on a timeout
  //             throw e;
  //             // 
  //             // return of(null);
  //           })
  //         )
  //         .subscribe(data => {
  //           self.hideLoading();
  //           if (data) resolve(data);
  //           else reject("Network timedout");
  //         }, error => {
  //           
  //           if (error.name !== undefined && error.name == "TimeoutError" || error.status === 0) {
  //             self.events.publish("consectus:network.slow", "Network timeout error occurred");
  //             self.hideLoading();
  //           } else {
  //             if (error.status == 404) {
  //               self.events.publish("consectus:404.error", error);
  //             }
  //             else if (error.status == 401) {
  //               self.events.publish("consectus:500.error", error);
  //             }
  //             else if (error.status == 500 || error.status == 400) {
  //               self.events.publish("consectus:500.error", error);
  //             }
  //             else if (error.status !== 0) {
  //               self.events.publish("consectus:network.error", error);
  //             }
  //             self.hideLoading();
  //           }
  //           reject(error);
  //         });
  //     }).catch((err) => {
  //       reject(err);
  //     })
  //   });
  // }

  /**
   * Common api for all delete method 
   * @param url 
   */
  call_delete(url, showLoading = false) {
    return this.enqueueRequest(() => {
      let self = this;
      if (showLoading) self.showLoading();
      return new Promise(function (resolve, reject) {
        self.getAccessToken().then((tokenData: any) => {
          let headers = new Headers();
          // headers.append('Access-Control-Allow-Origin', '*'),
          //   headers.append('Access-Control-Allow-Methods', 'POST, GET, PUT, DELETE'),
          headers.append('Access-Control-Allow-Origin', self.global.getBaseUrl());
          headers.append('Origin', self.global.getBaseUrl());
          headers.append('Content-Type', 'application/json');
          headers.append('Authorization', "Bearer " + tokenData.access_token);
          self.http.delete(self.global.getBaseUrl() + url, { headers: headers })
            .map(res => res.json())
            .pipe(
              timeout(self.global.ajaxTimeout),
              catchError(e => {
                // do something on a timeout

                // 
                throw e;
              })
            )
            .subscribe(data => {
              self.hideLoading();
              if (data) resolve(data);
              else reject("Network timedout");
            }, error => {

              if (error.name !== undefined && error.name == "TimeoutError" || error.status === 0) {
                self.hideLoading();
                self.events.publish("consectus:network.slow", "Network timeout error occurred");
              } else {
                if (error.status == 404) {

                  self.events.publish("consectus:404.error");
                }
                else if (error.status == 401) {
                  self.getAuthorizationCode().then((oauthTokenData: any) => {
                    if (oauthTokenData !== null || oauthTokenData !== '') {
                      window.document.cookie = "Authorization = Bearer % 2053bd0e70 - 4910 - 4ba6 - b017 - 5e829d76439b; domain = " + self.global.getBaseUrl();
                      self.getRefreshToken(
                        { "oldtoken": tokenData, "newtoken": oauthTokenData.access_token }
                      ).then((refresh_result: any) => {
                        if (refresh_result.status) {
                          self.call_delete(url)
                            .then((data) => {
                              resolve(data);
                            }).catch((err) => {
                              reject(err);
                            })
                        }
                        else {
                          self.events.publish("consectus:500.error", error);
                          //reject(refresh_result);
                        }
                      }).catch((refresh_token_err) => {
                        self.events.publish("consectus:500.error", error);
                        //reject(refresh_token_err);
                      })
                    }
                  }).catch((getAuthorizationCode_Err: any) => {
                    self.events.publish("consectus:500.error", error);
                    //reject(getAuthorizationCode_Err);
                  })
                  //self.events.publish("consectus:500.error", error);
                }
                else if (error.status == 500 || error.status == 400) {
                  self.events.publish("consectus:500.error");
                } else if (error.status === 503) {
                  window.show401(JSON.parse(error._body));
                } else if (error.status !== 0) {
                  self.events.publish("consectus:network.error", error);
                } else {
                  console.log(error);
                }
                self.hideLoading();
              }
              reject(error);

            });
        }).catch((err) => {
          reject(err);
        })
      });
    });
  }

  register(data) {
    return new Promise(function (resolve, reject) {
      resolve(true);
    })
  }

  getsavinganalyis(customer_accounts) {
    let self = this;
    let url = "/accounts/getsavinganalyis";
    self.flag = 0;
    return new Promise((resolve, reject) => {
      self.call_post(url, customer_accounts)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  getaccountrules() {
    let self = this;
    let url = '/accounts/getrulesengine';
    return new Promise((resolve, reject) => {
      self.call_get(url)
        .then((accountrules) => {
          resolve(accountrules);
        }).catch((err) => {
          reject(err);
        })
    });
  }

  getrulesenginebyaccounttypes(account_types_id) {
    let self = this;
    let url = '/accounts/getrulesenginebyaccounttypes';
    return new Promise((resolve, reject) => {
      self.call_post(url, account_types_id)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    });
  }

  getLabels(pagename) {
    let self = this;
    let headers = new Headers();
    headers.append('Content-type', 'application/json');
    headers.append('Authorization', "Bearer " + self.token)
    return new Promise(function (resolve, reject) {
      resolve(self.labels)
    });
  }

  getAPILabels() {
    let self = this;
    let headers = new Headers();
    headers.append('Content-type', 'application/json');
    headers.append('Authorization', "Bearer " + self.token)
    let url = '/register/getLabels';
    return new Promise(function (resolve, reject) {
      self.call_get(url)
        .then((applabels) => {
          resolve(applabels);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  setAppMarketingpreferences(marketProductInformation) {
    let self = this;
    let url = '/accounts/setmarketingpreferences';

    return new Promise(function (resolve, reject) {
      self.call_post(url, marketProductInformation)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        });
    });
  }

  setThirdPartyNotifications(thirdpartynotifications) {
    let self = this;
    let url = '/accounts/setthirdpartynotifications';

    return new Promise(function (resolve, reject) {
      self.call_post(url, thirdpartynotifications)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  setThirdpartyNumber(setthirdpartynumber) {
    let self = this;
    let url = '/accounts/setthirdpartynumber';

    return new Promise(function (resolve, reject) {
      self.call_post(url, setthirdpartynumber)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  /**
   * Update touch enable id
   */
  updateTouchId(touchID) {
    let self = this;
    let url = '/accounts/setistouchid';
    return new Promise(function (resolve, reject) {
      self.call_post(url, touchID)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err);
        })
    });
  }
  /**
   * Get app setting from customer table
   */

  getAppSettings(custormer_id) {
    let self = this;
    let url = '/accounts/getcustomerbycustomerid';
    self.flag = 1;
    return new Promise(function (resolve, reject) {
      self.call_post(url, custormer_id)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  getFaqs(category_id) {
    let self = this;
    let url = '/accounts/getfaqbycategoryid';
    let body = {
      "category_id": category_id
    }
    return new Promise(function (resolve, reject) {
      self.call_post(url, body)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  getFaqCategory() {
    let self = this;
    let url = '/register/getallcategories';
    return new Promise(function (resolve, reject) {
      self.call_get(url)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  getGoals(accountId) {
    let self = this;
    let url = '/accounts/getsavingsgoalsbyaccountid';
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, accountId)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  getAllGoal(customers_id) {
    let self = this;
    let url = '/accounts/getsavingsgoalsbycustomerid';
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, customers_id)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  addGoal(goaldata) {
    let self = this;
    let url = '/accounts/addsavingsgoal';
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, goaldata)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  addGoalv2(goaldata) {
    let self = this;
    let url = '/accounts/addsavingsgoalv2';
    return new Promise(function (resolve, reject) {
      self.call_post(url, goaldata)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  updateGoal(goal) {
    let self = this;
    let url = '/accounts/updatesavingsgoalv2';
    return new Promise(function (resolve, reject) {
      self.call_post(url, goal)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  removeGoal(deletegoal) {
    let self = this;
    let url = '/accounts/deletesavingsgoal';
    return new Promise(function (resolve, reject) {
      self.call_post(url, deletegoal)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  checkTransferValidation(tranferData) {
    let self = this;
    let url = '/accounts/checktransfervalidation';
    return new Promise(function (resolve, reject) {
      self.call_post(url, tranferData)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  transferMoney(tranferData) {
    let self = this;
    let url = '/accounts/transferout';
    return new Promise(function (resolve, reject) {
      self.call_post(url, tranferData)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  transferoutfinal(tranferData) {
    let self = this;
    let url = '/accounts/transferoutfinal';
    return new Promise(function (resolve, reject) {
      self.call_post(url, tranferData)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  getSavingsBalance(account) {
    var balance = 0;
    for (let t of this.savingstransactions[account].cleared) {
      balance += Number.parseFloat(t.amount);
    }
    return balance;

  }
  getSavingsAccounts() {
    let self = this;
    return new Promise(function (resolve, reject) {
      for (let account of self.savingsaccounts) {
        account.balance = self.getSavingsBalance(account.account_number);
        account.available = self.getSavingsBalance(account.account_number);
      }
      resolve(self.savingsaccounts);
    });
  }
  getCurrentAccounts() {
    let self = this;
    return new Promise(function (resolve, reject) {
      resolve(self.currentaccounts);
    });
  }
  getSavingsAccountTransactions(accountNumber: any) {
    let self = this;
    return new Promise(function (resolve, reject) {
      // setTimeout(()=>{
      var cleared = self.savingstransactions[accountNumber].cleared.sort((a, b) => {
        var ad = new Date(a.date); var bd = new Date(b.date);
        if (bd < ad) return -1;
        else if (bd > ad) return 1;
        else return 0
      });
      var pending = self.savingstransactions[accountNumber].pending.sort((a, b) => {
        var ad = new Date(a.date); var bd = new Date(b.date);
        if (bd < ad) return -1;
        else if (bd > ad) return 1;
        else return 0
      });
      var rejected = self.savingstransactions[accountNumber].rejected.sort((a, b) => {
        var ad = new Date(a.date); var bd = new Date(b.date);
        if (bd < ad) return -1;
        else if (bd > ad) return 1;
        else return 0
      });
      self.savingstransactions[accountNumber].cleared = cleared.reverse();
      self.savingstransactions[accountNumber].pending = pending;
      self.savingstransactions[accountNumber].rejected = rejected;
      resolve(self.savingstransactions[accountNumber]);
      // }, 1000);
    });
  }
  depositMoney(amount, toAccount, fromAccount, fromSortCode) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.savingstransactions[toAccount].cleared.push({
        account_number: toAccount,
        date: new Date().toISOString().split("T")[0], //YYYY-MM-DD
        amount: amount,
        status: 'pending',
        description: "Mobile App Transfer"
      });
      resolve(true);
    });
  }

  sendMoney(amount, fromAccount, toAccount, toSortCode) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.savingstransactions[fromAccount].cleared.push({
        account_number: fromAccount,
        date: new Date().toISOString().split("T")[0], //YYYY-MM-DD
        amount: -1 * amount,
        status: 'cleared',
        description: toAccount != null ? "Transfer Amount to Account : " + toAccount : "Mobile App Transfer"
      });

      self.savingstransactions[toAccount].cleared.push({
        account_number: fromAccount,
        date: new Date().toISOString().split("T")[0], //YYYY-MM-DD
        amount: 1 * amount,
        status: 'cleared',
        description: toAccount != null ? "Transfer Amount from Account : " + toAccount : "Mobile App Transfer"
      });
      resolve(true);
    });
  }
  deleteRejectedTransaction(transaction) {
    let self = this;
    let url = "/accounts/cancelpostdatedtransfer";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, transaction)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }
  getBranches() {
    let self = this;
    let url = '/accounts/getbranch';
    return new Promise(function (resolve, reject) {
      self.call_get(url)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  getProducts() {
    let self = this;
    let url = "/accounts/getproduct";
    return new Promise(function (resolve, reject) {
      self.call_get(url)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  getMaturityProducts(data) {
    let self = this;
    let url = "/accounts/getmaturityproduct";
    return new Promise(function (resolve, reject) {
      self.call_post(url, data)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  isProductRead(productid) {
    let self = this;
    let url = "/accounts/isproductread";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, productid)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  isProductInterested(productid) {
    let self = this;
    let url = "/accounts/isproductinterested";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, productid)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  getUniqueEmail(emailid) {
    let self = this;
    let url = "/accounts/getuniqueemail";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, emailid)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  getUniqueMobile(Mod) {
    let self = this;
    let url = "/accounts/getuniquenumber";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, Mod)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  updateProductApplicationStatus(status_state) {
    let self = this;
    let url = "/accounts/updateproductapplicationstatus";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, status_state)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  registerProductAction(product, url) {
    return new Promise(function (resolve, reject) {
      resolve(true);
    });
  }
  productViewed(p) {
    let self = this;
    return new Promise(function (resolve, reject) {
      for (let product of self.products) {
        if (product.id == p.id) {
          product.new = false;

        }
      }
      resolve(true);
    });
  }
  getNewProductCount() {
    let self = this;
    return new Promise(function (resolve, reject) {
      var count = 0;
      for (let product of self.products) {
        if (product.new) count += 1;
      }
      resolve(count);
    });
  }

  getMembers() {
    let self = this;
    let url = "/accounts/getmember";
    return new Promise(function (resolve, reject) {
      self.call_get(url)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  isMemberRead(memberid) {
    let self = this;
    let url = "/accounts/ismemberread";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, memberid)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  isMemberInterested(memberid) {
    let self = this;
    let url = "/accounts/ismemberinterested";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, memberid)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  getCurrentDate() {
    let self = this;
    let url = "/utilities/getcurrentdatetime";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_get(url)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  getMessages(body) {
    let self = this;
    let url = "/accounts/getmessagesbycustomerid";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, body)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    })
  }

  isMessageRead(pushmessagesid) {
    let self = this;
    let url = "/accounts/ismessageread";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, pushmessagesid)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  isMessageInterested(pushmessagesid) {
    let self = this;
    let url = "/accounts/ismessageinterested";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, pushmessagesid)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  registerMessageAction(message, url) {
    return new Promise(function (resolve, reject) {
      resolve(true);
    });
  }
  messageViewed(m) {
    let self = this;
    return new Promise(function (resolve, reject) {
      for (let message of self.messages) {
        if (message.id == m.id) {
          message.new = false;
        }
      }
      resolve(true);
    });
  }
  getNewMessageCount() {
    let self = this;
    return new Promise(function (resolve, reject) {
      var count = 0;
      for (let message of self.messages) {
        if (message.new) count += 1;
      }
      resolve(count);
    });
  }

  getMortgageAccountTransactions(customer_id) {
    let self = this;
    let customedata =
    {
      customer_id: customer_id
    }
    let url = "/accounts/getmortgageaccounts";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, customedata)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }
  getAllDocuments(accountno) {
    let self = this;
    let url = `/accounts/documents/${accountno}`;
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_get(url)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }
  getDocumentDownload(documentId) {
    let self = this;
    let url = `/accounts/documents/${documentId}/download`;
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.downloadstatementv2(url)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }
  documentDownload(documentId: string) {
    let self = this;
    let url = `/accounts/documents/${documentId}/download`;
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.downloadstatementv2(url)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }
  getOverpaymentValue(account_number) {
    let self = this;
    let url = `/calculators/${account_number}/overpayment`;
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_get(url)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }
  getRatechangeValue(account_number) {
    let self = this;
    let url = `/calculators/${account_number}/ratechange`;
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_get(url)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }
  getOverPaymentCalculate(data, account_number) {
    let self = this;
    let url = `/calculators/${account_number}/overpayment`;
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, data)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }
  getRateChangeCalculate(data, account_number) {
    let self = this;
    let url = `/calculators/${account_number}/ratechange`;
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, data)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }
  getRedemptionDetails(customer_id, accountno) {
    let self = this;
    let customedata =
    {
      customer_id: customer_id,
      account_number: accountno
    }
    let url = "/accounts/redemptionquotation";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, customedata)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  getMortgageRedemption(accountno) {
    let self = this;
    let customedata =
    {
      account_number: accountno
    }
    let url = "/accounts/mortgageredemption";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, customedata)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }
  getContactSubject() {
    let self = this;
    let url = "/accounts/getcontactsubject";
    return new Promise(function (resolve, reject) {
      self.call_get(url)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  customerComplaint(complaintData) {
    let self = this;
    let url = "/accounts/customercomplaint";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, complaintData)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  getCustomerComplaintByCustomerid(customerid) {
    let self = this;
    let url = "/accounts/getcustomercomplaintbycustomerid";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, customerid)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  getCustomerMessageByMessageid(customer_messenger) {
    let self = this;
    let url = "/accounts/getcontactusmessagebyid";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, customer_messenger)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  getUserMessageByMessageid(user_messenger) {
    let self = this;
    let url = "/accounts/getcontactusmessagebyid";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, user_messenger)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  sendMessageToStaffUser(messageToStaffUser) {
    let self = this;
    let url = "/accounts/sendmessagetostaffuser";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, messageToStaffUser)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  getCheques(customerid) {
    let self = this;
    let url = "/accounts/getchequelistbycustomerid";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, customerid)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  getChequesByAccountid(accountid) {
    let self = this;
    let url = "/accounts/getchequelistbyaccountid";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, accountid)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  addCheque(cheque) {
    let self = this;
    let url = "/accounts/addcheque";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, cheque)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  updateCheque(account, cheque) {
    let self = this;
    return new Promise(function (resolve, reject) {
      let arr = [];
      for (let g of self.cheques[account.accountno]) {
        if (g.id === cheque.id) {
          arr.push(cheque);
        } else {
          arr.push(g);
        }
      }
      self.cheques[account.accountno] = arr;
      resolve(true);
    });
  }
  removeCheque(account, cheque) {
    let self = this;
    return new Promise(function (resolve, reject) {
      let arr = [];
      for (let g of self.cheques[account.accountno]) {
        if (g.id !== cheque.id) {
          arr.push(g);
        }
      }
      self.cheques[account.accountno] = arr;
      resolve(true);
    });
  }
  getDirectDebits(byaccountno) {
    let self = this;
    let url = "/accounts/getregularsavingsbyaccountno";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, byaccountno)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  getAllRegularSavings(bycustomers_id) {
    let self = this;
    let url = "/accounts/getregularsavingsbycustomerid";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, bycustomers_id)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });

  }
  addDirectDebit(directdebit) {
    let self = this;
    let url = "/accounts/addregularsavings";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, directdebit)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });

  }

  updateSuspendDetails(data) {
    let self = this;
    return new Promise(function (resolve, reject) {
      let arr = [];


      for (let g of self.sweeper) {
        if (g.connection_id === data.connection_id) {
          arr.push(data);
        } else {
          arr.push(g);
        }
      }
      self.sweeper = arr;
      resolve(self.sweeper);
    });
  }

  deleteSuspendDetails(data) {
    let self = this;
    return new Promise(function (resolve, reject) {
      let arr = [];


      for (let g of self.sweeper) {
        if (g.connection_id !== data.connection_id) {
          arr.push(g);
        }
      }
      self.sweeper = arr;


      resolve(self.sweeper);
    });
  }

  removeSweeper(sweepdata) {
    let self = this;
    return new Promise(function (resolve, reject) {
      if (self.sweeper !== undefined) {
        for (let i = 0; i < self.sweeper.length; i++) {
          var arr = [];
          if (self.sweeper[i].connection_id === sweepdata.connection_id) {
          }
          else {
            arr.push(self.sweeper[i]);
          }
        }
        self.sweeper = JSON.parse(JSON.stringify(arr));
        resolve(self.sweeper);
      }
      else
        resolve([]);
    });
  }

  updateSweeperStatus(data) {
    let self = this;
    return new Promise(function (resolve, reject) {
      let arr = [];
      for (let g of self.sweeper) {
        if (g.connection_id === data.connection_id) {
          data.suspend.isactive = 0;
          arr.push(data);
        } else {
          arr.push(g);
        }
      }
      self.sweeper = arr;
      resolve(self.sweeper);
    });
  }


  updateDirectDebit(dd) {
    let self = this;
    let url = "/accounts/updateregularsavings";

    return new Promise(function (resolve, reject) {
      self.call_post(url, dd)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }


  removeDirectDebit(dd) {
    let self = this;
    let url = "/accounts/deleteregularsavings";

    return new Promise(function (resolve, reject) {
      self.call_post(url, dd)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });

  }


  addSaverConnection(data) {
    let self = this;
    return new Promise(function (resolve, reject) {
      if (self.smartsaver.connections === undefined) {
        self.smartsaver.connections = [];
      }
      for (let i of data) {
        if (self.smartsaver.connections.find((obj) => obj.accounts.account_number == i.accounts.accountno && obj.bank === i.bank) == undefined) {
          self.smartsaver.connections.push(i);
        }
      }
      resolve(self.smartsaver.connections);
    });
  }

  getAllSaverConnections() {
    let self = this;
    return new Promise(function (resolve, reject) {
      if (self.smartsaver.connections !== undefined)
        resolve(self.smartsaver.connections);
      else
        resolve([]);
    });
  }

  updateSaverConnection(data) {
    let self = this;
    return new Promise(function (resolve, reject) {
      let arr = [];
      for (let g of self.smartsaver.connections) {
        if (g.id === data.id) {
          arr.push(data);
        } else {
          arr.push(g);
        }
      }
      self.smartsaver.connections = arr;
      resolve(true);
    });
  }


  removeSaverConnection(connection) {
    let self = this;
    return new Promise(function (resolve, reject) {
      for (let i in self.smartsaver.savingrules) {
        if (self.smartsaver.savingrules[i].accounts.length == 1) {
          if (self.smartsaver.savingrules[i].accounts[0].accounts.account_number === connection.accounts.account_number && self.smartsaver.savingrules[i].accounts[0].bank === connection.bank) {
            self.smartsaver.savingrules[i].accounts = [];
          }
        }
        else {
          let uniqval = [];
          for (let k in self.smartsaver.savingrules[i].accounts) {
            if (self.smartsaver.savingrules[i].accounts[k].accounts.account_number !== connection.accounts.account_number) {
              uniqval.push(self.smartsaver.savingrules[i].accounts[k]);

            }
            else {
              if (self.smartsaver.savingrules[i].accounts[k].bank !== connection.bank) {
                uniqval.push(self.smartsaver.savingrules[i].accounts[k]);
              }
            }
          }
          self.smartsaver.savingrules[i].accounts = uniqval;
        }
      }
      resolve(true);
    });
  }

  getSavingRuleByConnection(connection) {
    let self = this;
    let filteredArray = [];
    return new Promise(function (resolve, reject) {
      if (self.smartsaver.savingrules != undefined) {
        filteredArray = self.smartsaver.savingrules.filter(el => {
          return el.accounts.some(e => {
            return e.accounts.account_number === connection.accounts.account_number && e.bank === connection.bank;
          });
        });
        resolve(filteredArray);
      }
      else {
        filteredArray = [];
        resolve(filteredArray);

      }
    });

  }

  getSaverTransaction() {
    let self = this;
    return new Promise(function (resolve, reject) {
      if (self.smartsaver_transaction !== undefined)
        resolve(self.smartsaver_transaction);
      else
        resolve([]);
    });
  }

  getSaverConnectionByAccountNo(accountno) {
    let self = this;
    return new Promise(function (resolve, reject) {
      let arr = self.smartsaver.connections.find((obj) => obj.accounts.account_number === accountno);
      resolve(arr);
    });
  }


  addConnectionRules(data) {
    let self = this;
    return new Promise(function (resolve, reject) {
      if (self.smartsaver.savingrules === undefined) {
        self.smartsaver.savingrules = [];
      }
      self.smartsaver.savingrules.push(data);
      resolve(true);
    });
  }

  addSweeperConnectionRules(data) {
    let self = this;
    return new Promise(function (resolve, reject) {
      if (self.sweeper === undefined) {
        self.sweeper = [];
      }
      self.sweeper.push(data);
      resolve(self.sweeper);
    });
  }

  getConnectionRules() {
    let self = this;
    return new Promise(function (resolve, reject) {
      if (self.smartsaver.savingrules !== undefined)
        resolve(self.smartsaver.savingrules);
      else
        resolve([]);
    });
  }

  getSweeperConnectionRules() {
    let self = this;
    return new Promise(function (resolve, reject) {
      if (self.sweeper !== undefined)
        resolve(self.sweeper);
      else
        resolve([]);
    });
  }


  updateConnectionRules(data) {
    let self = this;
    return new Promise(function (resolve, reject) {
      let arr = [];
      for (let g of self.smartsaver.savingrules) {
        if (g.id === data.id) {
          arr.push(data);
        } else {
          arr.push(g);
        }
      }
      self.smartsaver.savingrules = arr;
      resolve(true);
    });
  }


  removeConnectionRules(data) {
    let self = this;
    return new Promise(function (resolve, reject) {
      let arr = [];
      for (let g of self.smartsaver.savingrules) {
        if (g.id !== data.id) {
          arr.push(g);
        }
      }
      self.smartsaver.savingrules = arr;
      resolve(true);
    });
  }


  getConnectionTransaction(account_number) {
    let self = this;
    return new Promise(function (resolve, reject) {
      let returnval = self.connection_transactions.find((obj) => obj.account_number == account_number);
      resolve(returnval.transactions.reverse());
    });
  }

  // step one new account opening
  getaccounttypesandproducts() {
    let self = this;
    let url = "/accounts/getparentproducts";
    return new Promise(function (resolve, reject) {
      self.call_get(url)
        .then((data) => {

          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  getSubProducts(productId) {
    let self = this;
    let url = "/accounts/getsubproducts";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, productId, true)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  createNewAccount(newaccount) {
    let self = this;
    let url = "/accounts/createnewaccount";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, newaccount)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  getExistingCustomerDetails(customerId) {
    let self = this;
    let url = "/accounts/getexistingcustomerdetails";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, customerId)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  getProductExistingCustomerDetails(customerId, account_types_id, products_id) {
    // console.log(" getProductExistingCustomerDetails");

    let self = this;
    let customedata =
    {
      customers_id: customerId,
      account_types_id: account_types_id,
      products_id: products_id
    }
    let url = "/accounts/getexistingcustomerdetails";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, customedata)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }


  newAccountRegister(newaccount) {
    let self = this;
    let url = "/accounts/newaccountregister";
    // let url = "/accounts/newcustomeraccountregister"
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, newaccount)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  commonNewAccountRegister(newaccount) {
    let self = this;
    let url = "/accounts/newcustomeraccountregister"
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, newaccount)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  checkSopraRegistrationStatus(newaccount) {
    let self = this;
    let url = "/accounts/checksopraregistrationstatus";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, newaccount)
        .then((data) => {

          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  createAccountForExistingCustomer(newaccount) {
    let self = this;
    // let url = "/accounts/createaccountforexistingcustomerform";
    let url = "/accounts/createaccountforexisting";
    self.flag = 0;

    return new Promise(function (resolve, reject) {
      self.call_post(url, newaccount)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  verifySecurityCode(newaccount) {
    let self = this;
    let url = "/accounts/verifysecuritycode";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, newaccount, true)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }
  // Step One new account opening


  /**
   * Outhtoken for authorization
   */
  oauthToken() {
    let self = this;
    let body = new URLSearchParams();
    body.set('username', "Test");
    body.set('password', "$2a$10$R2xYGhoHvGi6hLfyBu4p9.tqOkmKl67zBrMDcjoAg/KTqdK6S1rw2");
    body.set('name', "Test");
    body.set('client_id', "4fad6c1c-27a0-5b35-a3ba-50dba1d80fda");
    body.set('client_secret', "d9e65941-ff50-5694-8d2a-7b30a73168de");
    body.set('grant_type', "password");

    let url = "/auth/login";
    self.flag - 1;
    return new Promise(function (resolve, reject) {
      self.oauth_post(url, body.toString())
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }


  /**
   *  Register Device Token for push notification
   *  @param registerDeviceTokenData
   */

  customerLoginInfo(login_info) {
    let self = this;
    let url = "/accounts/customerlogin";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, login_info)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  registerDeviceToken(registerDeviceTokenData) {
    let self = this;
    let url = "/register/registerdevicetoken";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, registerDeviceTokenData, false)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }
  registerDeviceTokenNew(registerDeviceTokenData) {
    let self = this;
    let url = "/register/registerdevicetoken_new";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, registerDeviceTokenData, false)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }
  registerNewCustomer(customerdata) {
    let self = this;
    let url = "/register/registernewcustomer";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, customerdata, false)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  /**
   * Update Device token for push notification
   * @param updateDeviceTokenData
   */

  updateDeviceToken(updateDeviceTokenData) {
    let self = this;
    let url = "/accounts/updatedevicetoken";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, updateDeviceTokenData)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }


  /**
   * Get Saving accounts
   * @param customerId
   */

  getCustomerAccounts(customerId) {
    let self = this;
    let url = "/accounts/getcustomeraccounts";
    let customedata =
    {
      customers_id: customerId
    }
    self.flag = 1;
    return new Promise(function (resolve, reject) {
      self.call_post(url, customedata, false)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }
  getCustomerSavingsAccounts(customerdata, pageno, pagesize) {
    let query = { "pageDetail": { "page": pageno, "pageSize": pagesize } }
    let self = this;
    let url = "/accounts/getcustomeraccountsv3?obj=" + JSON.stringify(query);
    self.flag = 1;
    return new Promise(function (resolve, reject) {
      self.call_post(url, customerdata, false)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  /**
   * Get Maturity Options
   * @param account_types_id
   */

  getMaturityOptions(customer_accounts_id) {
    let self = this;
    let url = "/accountrules/getmaturityoptions";

    self.flag = 1;
    return new Promise(function (resolve, reject) {
      self.call_post(url, customer_accounts_id)
        .then((data) => {


          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  /**
   * Get Maturity Options
   * @param customer_accounts_id
   */

  selectMaturityOption(selectedOption) {
    let self = this;
    let url = "/accountrules/selectmaturityoptionv2";

    self.flag = 1;
    return new Promise(function (resolve, reject) {
      self.call_post(url, selectedOption)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  deleteProductAccount(porduct_applied) {
    let self = this;
    let url = "/accounts/deleteproductaccount";
    self.flag = 1;
    return new Promise(function (resolve, reject) {
      self.call_post(url, porduct_applied)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  /**
     * Get Saving accounts Statements
     * @param customer_accounts_id
     */

  getCustomerAccountStatements(customer_accounts_id) {
    let self = this;
    let url = "/accounts/getcustomerstatementsbyaccount";
    let customedata =
    {
      customer_accounts_id: customer_accounts_id
    }
    self.flag = 1;
    return new Promise(function (resolve, reject) {
      self.call_post(url, customedata)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  /**
  * Get Customer account transaction by customer account Id
  * @param customeraccountId
  */

  getCustomerAccountTransactions(customeraccountId) {
    let self = this;
    let url = "/accounts/getaccountstransactions";
    let accountdata = {
      customer_accounts_id: customeraccountId
    };
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, accountdata, true, true)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  /**
   *  Transfer In api
   *  @param  accountdata
   */

  accessTransferIn(transferInData) {
    let self = this;

    let url = "/accounts/transferin";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, transferInData)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });

  }

  excessTransferIn(transferInData) {
    let self = this;
    let url = "/accounts/transferinv2";
    return new Promise(function (resolve, reject) {
      self.call_post(url, transferInData)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }


  /**
  *  Transfer Out api
  *  @param transferOutData
  */

  accessTransferOut(transferOutData) {
    let self = this;
    let url = "/accounts/transferout";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, transferOutData)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }


  /**
  * Excess Transfer Out api
  *  @param transferOutData
  */

  transferoutv2(transferOutData) {
    let self = this;
    let url = "/accounts/transferoutv2";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, transferOutData)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }


  /**
  *  Transfer Within api
  *  @param transferWithinData
  */

  sendMoneyWithinv2(transferWithinData) {
    let self = this;
    let url = "/accounts/transferwithinv2";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, transferWithinData)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });

  }

  /**
  *  Excess Transfer Within api
  *  @param transferWithinData
  */

  accessTransferWithin(transferWithinData) {
    let self = this;
    let url = "/accounts/transferwithin";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, transferWithinData)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });

  }

  pendingtransferlist(userLevel) {
    let self = this;
    let url = "/accounts/getpendingtransferlist";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, userLevel)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  approveTransfer(approvedTransferdata) {
    let self = this;
    let url = "/accounts/approvetransfer";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, approvedTransferdata)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });

  }

  denyTransfer(denyTransferdata) {
    let self = this;
    let url = "/accounts/denytransfer";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, denyTransferdata)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });

  }

  approveTransferv2(approvedTransferdata) {
    let self = this;
    let url = "/accounts/approvetransferv2";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, approvedTransferdata)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });


  }

  denyTransferv2(denyTransferdata) {
    let self = this;
    let url = "/accounts/denytransferv2";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, denyTransferdata)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });

  }

  /**  gateway cliet
   * Get count by pending orders
   */
  getCountByPendingOrders(pendingData) {
    let self = this;
    let url = "/accounts/getpendingrequestcount";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, pendingData)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }



  /**  gateway cliet
   * get Terms and Conditions
   */
  getTermsandCondition() {
    let self = this;
    let url = "/register/gettermsandcondition";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_get(url)
        .then((data: any) => {
          // data.data.onboarding = `<h2>What is Lorem Ipsum?</h2><p class="ql-align-justify"><strong>Lorem Ipsum</strong>&nbsp;is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p><h2>Why do we use it?</h2><p class="ql-align-justify">It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).</p><p><br></p><h2>Where does it come from?</h2><p class="ql-align-justify">Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32.</p><p class="ql-align-justify">The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham.</p><h5><br></h5>`
          // data.data.newaccount = data.data.onboarding;
          // data.data.product = data.data.onboarding;
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  checkMobileNo(checkMobileData) {
    let self = this;
    // let url = "/register/getcustomerbycontactno";
    let url = "/register/getcustomerbycontactno";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, checkMobileData, true)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }


  /**
   * Check existing mobile no
   * @param validMobileData 
   */
  checkExistingMobileNo(validMobileData) {
    let self = this;
    let url = "/accounts/getuniquenumbero";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, validMobileData)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }


  /**
   * Check existing mobile no
   * @param validMobileData 
   */
  checkExistingEmail(validEmailData) {
    let self = this;
    let url = "/accounts/getuniqueemail";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, validEmailData)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }


  /**
   * check new mobile for new customer
   * @param validMobileData 
   */
  checkNewMobileNo(checkMobileData) {
    let self = this;
    let url = "/register/checkfornewcustomerbycontactno";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, checkMobileData)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }



  verifyOtp(verifyData) {
    let self = this;
    let url = "/register/verifyotp";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, verifyData, true)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });

  }

  sendOtp(otpData) {
    let self = this;
    let url = "/register/sendotp";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, otpData, true)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  resendOtp(resend_otp) {
    let self = this;
    let url = "/register/resendotp";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, resend_otp)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  /**
   * Blocked custome
   * @param customerData 
   */
  blockCustomer(customerData) {
    let self = this;
    let url = "/accounts/blockcustomer";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, customerData)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }


  /**
   * Get Customer Details By Member Id 
   * @param memberIdData 
   */
  getcustomerByMemberId(memberIdData) {
    let self = this;
    let url = "/telephone/getcustomerbymemberid";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, memberIdData)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });

  }

  /**
  * Block Customer By MemberId
  * @param memberIdData 
  */
  blockexistingcustomerbymemberid(memberIdData) {
    let self = this;
    let url = "/register/blockexistingcustomerbymemberid";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, memberIdData)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  /**
  * New exsiting Blocked Customer By MemberId
  * @param memberIdData 
  */
  blocknewexistingcustomerbymemberid(memberIdData) {
    let self = this;
    let url = "/register/blockexistingcustomerbymemberid";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, memberIdData)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  /**
   * Block Customer By customerID
   * @param customerIdData 
   */
  blockcustomerbyCustomerId(customerIdData) {
    let self = this;
    let url = "/register/blockexistingcustomerbyid";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, customerIdData)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  /**
   * Set pin after registration
   * @param setPinData 
   */
  setPin(setPinData) {
    let self = this;
    let url = "/register/setexistingpinonline";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, setPinData)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });

  }
  setPassword(setPasswordData) {
    let self = this;
    let url = "/register/setexistingpasswordonline";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, setPasswordData)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });

  }

  getaccounttypes() {
    let self = this;
    let url = '/accountrules/getaccounttypes';
    self.flag = 0;
    return new Promise((resolve, reject) => {
      self.call_get(url)
        .then((accountrules) => {
          resolve(accountrules);
        }).catch((err) => {
          reject(err);
        })
    });


  }

  saveNewAccountCustomer(customerDetails) {
    let self = this;
    let url = "/register/createaccount";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, customerDetails)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }



  insertnewaccountwithoutcallcredit(customerDetails) {
    let self = this;
    let url = "/accounts/insertnewaccountwithoutcallcredit";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, customerDetails)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  newcustomeraccountregisteraftersmartsearch(customerDetails) {
    let self = this;
    let url = "/accounts/newcustomeraccountregisteraftersmartsearch";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, customerDetails)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  addupdatepycassodocs(customerDetails) {
    let self = this;
    let url = "/accounts/addupdatepycassodocs";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, customerDetails)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  /**
   * Blocked customer 
   * @param deviceData 
   */
  changeCustomerStatus(deviceData) {
    let self = this;
    let url = "/register/blockexistingcustomer";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, deviceData, true)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }


  /**
   * Blocked OTP 
   * @param deviceData 
   */
  blockOTP(deviceData) {
    let self = this;
    let url = "/register/blockotp";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, deviceData)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  /**
   * Blocked OTP 
   * @param blockActiveCustomer 
   */
  blockActiveCustomer(deviceData) {
    let self = this;
    let url = "/accounts/blockcustomerv2";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, deviceData)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  getCustomerBadgeCount(customers_id) {
    let self = this;
    let url = "/accounts/getcustomerbadgecount";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, customers_id)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }



  addStateStatusOfaccount(createAccount) {
    let self = this;
    let url = "/register/updatecreateaccount";
    return new Promise(function (resolve, reject) {
      self.call_post(url, createAccount, true)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }


  registerCreateAccount(createAccount) {
    let self = this;
    self.flag = 0;
    let url = "/register/registercreateaccount";
    return new Promise(function (resolve, reject) {
      self.call_post(url, createAccount)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  loadaudit(body) {
    let self = this;
    let url = "/accounts/loadaudit";
    self.flag = 1;
    return new Promise(function (resolve, reject) {
      self.call_post(url, body, false)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  /*
   * Name : commonLoader
   * Description : commonLoader for whole the application
   */

  commonLoader() {
    this.loader = this.loadingCtrl.create({
      content: "Please wait 123..."
    });
    this.loader.present();
  }

  /**
     * Show loader after successr
     */
  showLoading() {
    if (!this.loading) {
      this.loading = this.loadingCtrl.create();
      this.loading.present();
    }
  }

  /**
   * Hide loader after success and error
   */
  hideLoading() {
    if (this.loading) {
      this.loading.dismiss();
      this.loading = null;
    }
  }

  /**
   * Get status of the register customer
   * @param statusData 
   */
  getStatus(statusData) {
    let self = this;
    let url = "/register/getstatus";
    self.flag = 1;
    return new Promise(function (resolve, reject) {
      self.call_post(url, statusData, false)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  /**
  * Get status of the register customer
  * @param statusData 
  */
  getStatusbyUUID(statusData) {
    let self = this;
    let url = "/register/getstatusbyuuid";
    self.flag = 1;
    return new Promise(function (resolve, reject) {
      self.call_post(url, statusData, false)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  /**
   * Get status of the existing customer product application
   * @param statusData 
   */
  getProductApplicationStatus(statusData) {
    let self = this;
    let url = "/register/getstatusforproductapplication";
    self.flag = 1;
    return new Promise(function (resolve, reject) {
      self.call_post(url, statusData, false)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  /**
  * Get status of the register customer
  * @param customerStatusData 
  */
  getCustomerStatus(statusData) {
    let self = this;
    let url = "/register/getcustomerstatus";
    self.flag = 1;
    return new Promise(function (resolve, reject) {
      self.call_post(url, statusData)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  /**
  * Get status of the register customer
  * @param customerStatusData 
  */
  registernewexistingcustomer(registerData) {
    let self = this;
    let url = "/register/registernewexistingcustomer";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, registerData)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  /**
   * Block existing register data
   * @param registerData 
   */
  blockNewExistingCustomer(registerData) {
    let self = this;
    let url = "/register/blocknewexistingcustomerbymemberid";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, registerData)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  /**
   * Get registration fields for register page 
   */
  getRegistrationFields() {
    let self = this;
    let url = "/register/getregistrationfieldsv1";
    return new Promise(function (resolve, reject) {
      self.call_get(url)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }



  /**
   * Get Onboarding Process for verify customer
   */
  getOnboardingProcess() {
    let self = this;
    let url = "/register/getonboardingprocess";
    return new Promise(function (resolve, reject) {
      self.call_get(url)
        .then((data) => {

          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  /**
   * Verify Register form
   * Remove this api
   * @param verifyData 
   */
  verifyRegistrationdata(verifyData) {
    let self = this;
    let url = "/register/verifyregistrationdata";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, verifyData)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  /**
   * Verify Member Id
   * @param verifyData 
   */
  verifyMemberId(verifyData) {
    let self = this;
    let url = "/register/verifymemberid";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, verifyData)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  /**
   * Update New account Member ID
   * @param postData 
   */
  updateNewAccountMemberID(postData) {
    let self = this;
    let url = "/register/getcustomerdetailsbymemberidv1";
    return new Promise(function (resolve, reject) {
      self.call_post(url, postData)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  /**
   * Get Login Process flags to checkotouch id 
   */
  getloginprocess() {
    let self = this;
    let url = "/register/getloginprocess";
    return new Promise(function (resolve, reject) {
      self.call_get(url)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  /**
   * Register Data
   * @param registerData 
   */
  newOnBoardingRegister(registerData) {
    let self = this;
    let url = "/register/newonboardingregister";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, registerData, true)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  /**
   * verifyregisterformsopra
   * @param registerData 
   */
  verifyregisterformsopra(registerData) {
    let self = this;
    let url = "/register/verifyregisterformsopra";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, registerData, true)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  /**
   * VerifyMailer data using member id 
   * @param verifyMailerData 
   */
  verifyMailer(verifyMailerData) {
    let self = this;
    let url = "/register/verifymailer";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, verifyMailerData, true)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }
  /**
   * VerifyMailer data using member id 
   * @param verifyMailerData 
   */
  verifymailerforgotpin(verifyMailerData) {
    let self = this;
    let url = "/register/verifymailerforgotpin";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, verifyMailerData, true)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  /**
     * VerifyMailer data using member id 
     * @param sendTermsAndConditions
     */
  sendTnCMail(sendMail) {
    let self = this;
    let url = "/register/sendtncmail";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, sendMail, true)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  /**
  * VerifyMailer data using member id 
  * @param verifyMailerData 
  */
  getContactSubjectBySubject(blockSubject) {
    let self = this;
    let url = "/register/getcontactsubjectbysubject";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, blockSubject)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  /**
  * Get all bank settings 
  * @param verifyMailerData 
  */
  async getAccountBanksetting(devicetype) {
    let self = this;
    let url = "/accounts/getbanksettings";
    return new Promise((resolve, reject) => {
      self.call_post(url, devicetype)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    })
  }
  async getRegisterationStatus() {
    let self = this;
    let url = "/register/getregistrationfieldsv1";
    return new Promise(function (resolve, reject) {
      self.call_get(url)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }
  /**
   * Checked blocked status of the customerdata
   * @param customerdata 
   */
  getBlockedCustomerStatus(customerdata) {
    let self = this;
    // let url = "/register/getcustomerstatus";
    let url = "/register/getcustomerstatus";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, customerdata)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  /**
   * Verify data
   * @param verifyData 
   */
  verifydevicepinfornewexisting(verifyData) {
    let self = this;
    let url = "/register/verifydevicepinfornewexisting";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, verifyData, true)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  /**
   * Verify data
   * @param verifyData 
   */
  verifydevicepinforexisting(verifyData) {
    let self = this;
    let url = "/register/verifydevicepinforexisting";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, verifyData)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  /**
   * Login api for the verify pin
   * @param loginData 
   */
  loginwithpin(loginData) {
    let self = this;
    let url = "/accounts/loginwithpin";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, loginData, false)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });

  }

  /**
   * Login api for the verify pin
   * @param loginData 
   */
  loginWithTouchId(loginData) {
    let self = this;
    let url = "/accounts/loginwithtouchid";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, loginData)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });

  }

  /**
    *   Get autorization code
    */
  getAuthoriztionCode(postData) {
    let self = this;
    let url = "/oauth2/authorization_code";
    self.flag = 1;
    return new Promise(function (resolve, reject) {
      self.oauth_post(url, postData.toString())
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  /**
   *   Get token by autorization code
   */
  getToken(postData) {
    let self = this;
    let url = "/oauth2/token";
    self.flag = 1;
    return new Promise(function (resolve, reject) {
      self.oauth_post(url, postData.toString())
        .then((data: any) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  /**
   *   Get token by autorization code
   */
  getRefreshToken(postData) {
    let self = this;
    let url = "/oauth2/refreshtoken";
    self.flag = 1;

    return new Promise(function (resolve, reject) {
      self.oauth_post(url, postData)
        .then((data: any) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  refreshToken() {
    let self = this;
    let url = "/oauth2/refreshtoken";
    self.flag = 1;
    return new Promise(function (resolve, reject) {
      const data = { "refreshToken": self.refresh_token }
      self
        .oauth_post(url, data)
        .then((response: any) => {
          if (response.status) {
            self.token = response.access_token;
            self.expires_in = response.expires_in * 1000;
            self.expires = new Date(new Date().getTime() + parseInt(self.expires_in));
            self.refresh_token = response.refresh_token;
            self.refresh_token_expires_in = response.refresh_expires_in * 1000;
            self.refresh_token_expires = new Date(new Date().getTime() + parseInt(self.refresh_token_expires_in));
          }
          resolve(self.token);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  /**
   * Check access token for the each app
   * @param fresh 
   */
  getAccessToken(fresh = false) {
    //if token exists check if the expires time is in next 2 seconds
    let currentDate: any = new Date();
    let self = this;
    return new Promise(function (resolve, reject) {
      if (
        self.token &&
        !fresh &&
        self.expires - currentDate > self.renewBeforeMilliseconds
      ) {
        resolve(self.token);
      } else {
        if (self.token) {
          self
            .refreshToken()
            .then((token: string) => {
              if (token) {
                resolve(token);
              }
            })
            .catch((error: any) => {
              reject(error);
            });
        } else {
          self
            .getAuthorizationCode()
            .then((oauthTokenData: any) => {
              if (oauthTokenData !== null || oauthTokenData !== "") {
                resolve(oauthTokenData.token);
              }
            })
            .catch((error: any) => {
              reject(error);
            });
        }
      }
    });
  }

  /**
   * Get Authorization code for generate the passcode
   */
  getAuthorizationCode() {
    let self = this;
    let verifier_code = self.getVerifierCode();
    let code_challenge = verifier_code
    let state = CryptoJS.lib.WordArray.random(32) + "";
    return new Promise(function (resolve, reject) {
      let postData = new URLSearchParams();
      postData.set('code_challenge', code_challenge);
      postData.set('client_id', "consectus-api");
      postData.set('state', state);
      postData.set('response_type', "code");
      postData.set('code_challenge_method', "s256");
      self.getAuthoriztionCode(postData).then((authdata: any) => {
        if (authdata !== null || authdata !== '') {
          if (authdata.code !== null) {
            let resend_data = new URLSearchParams();
            resend_data.set('code', authdata.code);
            resend_data.set('state', state);
            resend_data.set('client_id', "consectus-api");
            resend_data.set('verifier_code', verifier_code);
            resend_data.set('code_challenge_method', "plain");
            resend_data.set('grant_type', "authorization_code");
            self.getToken(resend_data).then((authtoken: any) => {
              self.token = authtoken.access_token;
              self.expires_in = authtoken.expires_in * 1000;
              self.expires = new Date(
                new Date().getTime() + parseInt(self.expires_in)
              );
              self.refresh_token = authtoken.refresh_token;
              self.refresh_token_expires_in = authtoken.refresh_expires_in * 1000;
              self.refresh_token_expires = new Date(
                new Date().getTime() + parseInt(self.refresh_token_expires_in)
              );
              resolve(authtoken);
            }).catch((error) => {
              reject(error);
            });
          }
        }

      }).catch((error) => {
        reject(error);
      })
    });
  }

  /**
   * Check verifycode for the generate the token
   *    
   * */
  getVerifierCode() {
    let code = CryptoJS.lib.WordArray.random(32);
    let verifier_code = CryptoJS.enc.Base64.stringify(code);
    return verifier_code.replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=/g, '');
  }

  getCodeChallenge(code) {
    // 
    let encCode = CryptoJS.enc.Base64.stringify(CryptoJS.SHA256(code));
    return encCode.replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=/g, '');
  }

  /**
   * Validate reset pin
   * @param newaccount 
   */
  validateresetpin(resetpindata) {
    let self = this;
    let url = "/accounts/validateresetpin";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, resetpindata)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  /**
   * Validate reset pin
   * @param newaccount 
   */
  resetpin(resetpindata) {
    let self = this;
    let url = "/accounts/resetpin";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, resetpindata)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  getaccountbalance(balanceData) {
    let self = this;
    let url = "/accounts/getaccountbalance";
    self.flag = 1;
    return new Promise(function (resolve, reject) {
      self.call_post(url, balanceData)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  postalcodeapi_fail() {
    let self = this;
    let url = "/accounts/postcodemail";
    self.flag = 1;
    return new Promise(function (resolve, reject) {
      self.call_get(url)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  /**
   * Timeout error
   * @param title 
   * @param msg 
   */
  showWarning(title, msg) {
    let alert = this.alertCtrl.create({
      title: title,
      message: msg,
      buttons: [
        {
          text: 'OK',
          role: 'ok',
          handler: () => {
          }
        }
      ]
    });
    alert.present();
  }


  // PayCasso API

  p_start_session(consumer_ref, showLoading = false) {
    let self = this;
    if (showLoading) self.showLoading();
    return new Promise(function (resolve, reject) {
      let headers = new Headers();
      headers.append('Authorization', 'MQ9SqkIUN3c4LKo#');
      headers.append('Access-Control-Allow-Origin', '*');
      headers.append('Access-Control-Allow-Methods', 'POST, GET, PUT, DELETE');
      headers.append('Accept', 'application/json');
      headers.append('Content-Type', 'application/json');
      headers.append('PaycassoVersion', '2.10');
      let bodyParams = {
        "accountNumber": "bathuat",
        "appUserId": "YourAppUserID",
        "transactionType": "Registration",
        "deviceId": "YouDeviceID",
        "consumerRef": consumer_ref
      }
      self.http.post(self.global.getBaseUrl() + "/proxy/pycassosession", bodyParams, { headers: headers })
        .map(res => res.json())
        .pipe(
          timeout(self.global.ajaxTimeout),
          catchError(e => {
            throw e;
          })
        )
        .subscribe(result => {
          self.hideLoading();
          if (result.status) {
            self.paycasso_session = result.data;
            resolve(self.paycasso_session);
          }
          else reject("Network timedout");
        }, error => {
          if (error.name !== undefined && error.name == "TimeoutError" || error.status === 0) {
            self.events.publish("consectus:network.slow", "Network timeout error occurred");
            self.hideLoading();
          } else {
            if (error.status == 404) {
              self.events.publish("consectus:404.error", error);
            }
            else if (error.status == 401) {
              self.events.publish("consectus:401.error", error);
            }
            else if (error.status == 500 || error.status == 400) {
              self.events.publish("consectus:500.error", error);
            }
            else if (error.status !== 0) {
              self.events.publish("consectus:network.error", error);
            }
            self.hideLoading();
          }
          reject(error);
        });
    });
  }

  p_authorisedlogin(showLoading = false) {
    let self = this;
    if (showLoading) self.showLoading();
    return new Promise(function (resolve, reject) {
      let headers = new Headers();
      headers.append('Content-Type', 'application/json');
      let bodyParams = {
        details: self.paycasso_session,
        origin: "http://test.com:3000"
      };
      self.http.post(self.global.getBaseUrl() + "/proxy/pycassoauthorizedlogin", bodyParams, { headers: headers })
        .map(res => res.json())
        .pipe(
          timeout(self.global.ajaxTimeout),
          catchError(e => {
            throw e;
          })
        )
        .subscribe(result => {
          self.hideLoading();
          if (result.status) {
            self.paycasso_token = result.data.token;
            resolve(self.paycasso_token);
          }
          else reject("Network timedout");
        }, error => {
          if (error.name !== undefined && error.name == "TimeoutError" || error.status === 0) {
            self.events.publish("consectus:network.slow", "Network timeout error occurred");
            self.hideLoading();
          } else {
            if (error.status == 404) {
              self.events.publish("consectus:404.error", error);
            }
            else if (error.status == 401) {
              self.events.publish("consectus:401.error", error);
            }
            else if (error.status == 500 || error.status == 400) {
              self.events.publish("consectus:500.error", error);
            }
            else if (error.status !== 0) {
              self.events.publish("consectus:network.error", error);
            }
            self.hideLoading();
          }
          reject(error);
        });
    });
  }

  p_newtransaction(bodyParam, showLoading = false) {
    let self = this;
    if (showLoading) self.showLoading();
    return new Promise(function (resolve, reject) {
      let headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('token', self.paycasso_token);
      self.http.post(self.global.getBaseUrl() + "/proxy/pycassonewtransaction", bodyParam, { headers: headers })
        .map(res => res.json())
        .pipe(
          timeout(self.global.ajaxTimeout),
          catchError(e => {
            throw e;
          })
        )
        .subscribe(result => {
          self.hideLoading();
          if (result.status) {
            self.paycasso_transaction_id = result.data.transactionId;
            resolve(self.paycasso_transaction_id);
          }
          else reject("Network timedout");
        }, error => {
          if (error.name !== undefined && error.name == "TimeoutError" || error.status === 0) {
            self.events.publish("consectus:network.slow", "Network timeout error occurred");
            self.hideLoading();
          } else {
            if (error.status == 404) {
              self.events.publish("consectus:404.error", error);
            }
            else if (error.status == 401) {
              self.events.publish("consectus:401.error", error);
            }
            else if (error.status == 500 || error.status == 400) {
              self.events.publish("consectus:500.error", error);
            }
            else if (error.status !== 0) {
              self.events.publish("consectus:network.error", error);
            }
            self.hideLoading();
          }
          reject(error);
        });
    });
  }

  P_uploadFront(bodyParam, showLoading = false) {
    let self = this;
    if (showLoading) self.showLoading();
    return new Promise(function (resolve, reject) {
      let headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('token', self.paycasso_token);
      bodyParam.transactionid = self.paycasso_transaction_id

      self.http.post(self.global.getBaseUrl() + "/proxy/pycassosubmitfaceside", bodyParam, { headers: headers })
        .map(res => res.json())
        .pipe(
          timeout(self.global.ajaxTimeout),
          catchError(e => {
            throw e;
          })
        )
        .subscribe(result => {
          self.hideLoading();
          resolve(result);
          // if (result.status) {
          //   resolve(result);
          // }
          // else reject("Network timedout");
        }, error => {
          if (error.name !== undefined && error.name == "TimeoutError" || error.status === 0) {
            self.events.publish("consectus:network.slow", "Network timeout error occurred");
            self.hideLoading();
          } else {
            if (error.status == 404) {
              self.events.publish("consectus:404.error", error);
            }
            else if (error.status == 401) {
              self.events.publish("consectus:401.error", error);
            }
            else if (error.status == 500 || error.status == 400) {
              self.events.publish("consectus:500.error", error);
            }
            else if (error.status !== 0) {
              self.events.publish("consectus:network.error", error);
            }
            self.hideLoading();
          }
          reject(error);
        });
    });
  }

  P_uploadBack(bodyParam, showLoading = false) {
    let self = this;
    if (showLoading) self.showLoading();
    return new Promise(function (resolve, reject) {
      let headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('token', self.paycasso_token);
      bodyParam.transactionid = self.paycasso_transaction_id
      self.http.post(self.global.getBaseUrl() + "/proxy/pycassosubmitfaceside", bodyParam, { headers: headers })
        .map(res => res.json())
        .pipe(
          timeout(self.global.ajaxTimeout),
          catchError(e => {
            throw e;
          })
        )
        .subscribe(result => {
          self.hideLoading();
          resolve(result);
          // if (result.status) {
          //   resolve(result);
          // }
          // else reject("Network timedout");
        }, error => {
          if (error.name !== undefined && error.name == "TimeoutError" || error.status === 0) {
            self.events.publish("consectus:network.slow", "Network timeout error occurred");
            self.hideLoading();
          } else {
            if (error.status == 404) {
              self.events.publish("consectus:404.error", error);
            }
            else if (error.status == 401) {
              self.events.publish("consectus:401.error", error);
            }
            else if (error.status == 500 || error.status == 400) {
              self.events.publish("consectus:500.error", error);
            }
            else if (error.status !== 0) {
              self.events.publish("consectus:network.error", error);
            }
            self.hideLoading();
          }
          reject(error);
        });
    });
  }

  P_GetSummary(showLoading = false) {
    let self = this;
    if (showLoading) self.showLoading();
    return new Promise(function (resolve, reject) {
      let headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('token', self.paycasso_token);
      let bodyParam = {
        "transactionid": self.paycasso_transaction_id
      }
      self.http.post(self.global.getBaseUrl() + "/proxy/pycassotransactionsummary", bodyParam, { headers: headers })
        .map(res => res.json())
        .pipe(
          timeout(self.global.ajaxTimeout),
          catchError(e => {
            throw e;
          })
        )
        .subscribe(result => {
          self.hideLoading();
          if (result.status) {
            resolve(result);
          }
          else reject("Network timedout");
        }, error => {
          if (error.name !== undefined && error.name == "TimeoutError" || error.status === 0) {
            self.events.publish("consectus:network.slow", "Network timeout error occurred");
            self.hideLoading();
          } else {
            if (error.status == 404) {
              self.events.publish("consectus:404.error", error);
            }
            else if (error.status == 401) {
              self.events.publish("consectus:401.error", error);
            }
            else if (error.status == 500 || error.status == 400) {
              self.events.publish("consectus:500.error", error);
            }
            else if (error.status !== 0) {
              self.events.publish("consectus:network.error", error);
            }
            self.hideLoading();
          }
          reject(error);
        });
    });
  }

  getProductinformation() {
    let self = this;
    let url = "/accounts/getproductsinformation";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_get(url)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  downloadPDF(file_name) {
    let self = this;
    let url = "/proxy/rpaserverproxy/download";
    let bodyData = {
      "url": "/estimated/download",
      data: { filename: file_name },
      content_type: "application/javascript",
      method: 'POST'
    }
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, bodyData)
        .then((data: any) => {
          // resolve(data.fullurl + self.token) //commented for hardcode auth.
          resolve(data.fullurl + self.token)//shivkumar
        }).catch((err) => {
          reject(err)
        })
    });
  }

  updatemarketing(data) {
    let self = this;
    let url = "/accounts/updatemarketing";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, data)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }


  updatenominatedbankdetails(data) {
    let self = this;
    let url = "/accounts/updatenominatedbankdetails";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, data)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }


  insertexistingaccontwithoutcallcredit(body) {
    let self = this;
    let url = "/accounts/insertexistingaccontwithoutcallcredit";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, body)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  updateaccountsdata(body) {
    let self = this;
    let url = "/accounts/updateaccountsdata";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, body)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }


  getAppVersion() {
    let self = this;
    let url = "/register/getappversion";
    return new Promise(function (resolve, reject) {
      self.call_get(url)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  getGenderTitle() {
    let self = this;
    let url = "/register/getgendertitle";
    return new Promise(function (resolve, reject) {
      self.call_get(url)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  jumio(url, body, showLoading = true) {
    let self = this;

    if (showLoading) self.showLoading();
    return new Promise(function (resolve, reject) {
      self.getAccessToken().then((tokenData: any) => {
        let headers = new Headers();
        // headers.append('Access-Control-Allow-Origin', '*');
        // headers.append('Access-Control-Allow-Methods', 'POST, GET, PUT, DELETE');
        headers.append('Access-Control-Allow-Origin', self.global.getBaseUrl());
        headers.append('Origin', self.global.getBaseUrl());
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        headers.append('Content-Length', '1234');
        headers.append('User-Agent', 'Example Corp SampleApp/1.0.1');
        headers.append('Authorization', "Basic 92616e02-83b8-4388-bf9f-0a6e052b680c");
        self.http.post(self.global.getBaseUrl() + url, body, { headers: headers })
          .map(res => res.json())
          .pipe(
            timeout(self.global.ajaxTimeout),
            catchError(e => {
              // do something on a timeout

              // 
              // return of(null);
              throw e;
            })
          )
          .subscribe(data => {
            self.hideLoading();
            if (data) resolve(data);
            else reject("Network timedout");

          }, error => {

            if (error.name !== undefined && error.name == "TimeoutError" || error.status === 0) {
              self.events.publish("consectus:network.slow", "Network timeout error occurred");
              self.hideLoading();
            } else {
              if (error.status == 404) {
                self.events.publish("consectus:404.error", error);
              }
              else if (error.status == 401) {
                self.events.publish("consectus:401.error", error);
              }
              else if (error.status == 500 || error.status == 400) {
                self.events.publish("consectus:500.error", error);
              }
              else if (error.status !== 0) {

                self.events.publish("consectus:network.error", error);
              }
              self.hideLoading();
            }
            reject(error);
          });
      }).catch((err) => {
        reject(err);
      })
    });
  }

  jumio_get(url, showLoading = false) {
    let self = this;

    if (showLoading) self.showLoading();
    return new Promise(function (resolve, reject) {
      self.getAccessToken().then((tokenData: any) => {
        let headers = new Headers();
        // headers.append('Access-Control-Allow-Origin', '*');
        // headers.append('Access-Control-Allow-Methods', 'POST, GET, PUT, DELETE');
        headers.append('Access-Control-Allow-Origin', self.global.getBaseUrl());
        headers.append('Origin', self.global.getBaseUrl());
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        headers.append('Content-Length', '1234');
        headers.append('User-Agent', 'Example Corp SampleApp/1.0.1');
        headers.append('Authorization', "Basic 92616e02-83b8-4388-bf9f-0a6e052b680c");
        self.http.post(url, { headers: headers })
          .map(res => res.json())
          .pipe(
            timeout(self.global.ajaxTimeout),
            catchError(e => {
              // do something on a timeout

              // 
              // return of(null);
              throw e;
            })
          )
          .subscribe(data => {
            self.hideLoading();
            if (data) resolve(data);
            else reject("Network timedout");
          }, error => {
            if (error.name !== undefined && error.name == "TimeoutError" || error.status === 0) {
              self.events.publish("consectus:network.slow", "Network timeout error occurred");
              self.hideLoading();
            } else {
              if (error.status == 404) {
                self.events.publish("consectus:404.error", error);
              }
              else if (error.status == 401) {
                self.events.publish("consectus:401.error", error);
              }
              else if (error.status == 500 || error.status == 400) {
                self.events.publish("consectus:500.error", error);
              }
              else if (error.status !== 0) {
                self.events.publish("consectus:network.error", error);
              }
              self.hideLoading();
            }
            reject(error);
          });
      }).catch((err) => {
        reject(err);
      })
    });
  }

  getCountryList() {
    let self = this;
    let url = "/register/getcountrylist";
    return new Promise(function (resolve, reject) {
      self.call_get(url)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  complaintreplyisread(body) {
    let self = this;
    let url = "/register/updatecomplaintreplyisread";
    return new Promise(function (resolve, reject) {
      self.call_post(url, body)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  setaddressverified(body) {
    let self = this;
    let url = "/accounts/setaddressverified";
    return new Promise(function (resolve, reject) {
      self.call_post(url, body)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  getsopraconfig() {
    let self = this;
    let url = '/accounts/getsopraconfig';
    return new Promise((resolve, reject) => {
      self.call_get(url)
        .then((accountrules) => {
          resolve(accountrules);
        }).catch((err) => {
          reject(err);
        })
    });
  }
  getmaileractive(body) {
    let self = this;
    let url = '/register/lastrequestedforgotmailer';
    return new Promise((resolve, reject) => {
      self.call_post(url, body)
        .then((accountrules) => {
          resolve(accountrules);
        }).catch((err) => {
          reject(err);
        })
    });
  }

  sendfeedback(body) {
    let self = this;
    let url = '/feedback/sendfeedback';
    return new Promise((resolve, reject) => {
      self.call_post(url, body)
        .then((accountrules) => {
          resolve(accountrules);
        }).catch((err) => {
          reject(err);
        })
    });
  }

  sslPinning(url) {
    let self = this;
    let applive_ssl_fingerprint = "1A 30 EC 13 22 BE 5D DC 28 6F 5E 0B FE 30 DE 9A B7 F9 7C D7 5E 7A AD 05 5F 27 BF 1B 5C E8 FF 49";
    let apptest_ssl_fingerprint = "95 90 A9 81 75 9E 40 22 57 5C 9D 3E 26 DB 32 B5 5B F3 54 82 A7 15 17 60 31 33 D9 F2 BE 7C 59 FF";
    let sslMessage = "";
    window.plugins.sslCertificateChecker.check(
      successCallback,
      errorCallback,
      self.global.getBaseUrl() + url,
      applive_ssl_fingerprint);

    function successCallback(message) {

      sslMessage = message
      if (sslMessage == "CONNECTION_SECURE") {
        window.hideConnectionNotSecure();
      }
    }

    function errorCallback(message) {

      if (sslMessage != "CONNECTION_SECURE") {
        if (message === "CONNECTION_NOT_SECURE") {
          sslMessage = message;
        } else if (message.indexOf("CONNECTION_FAILED") > - 1) {
          sslMessage = "CONNECTION_FAILED";
        }
      }
    }
    return sslMessage;
  }

  validateToken(url) {
    let self = this;
    let req_body = {
      "uuid": "1502-1f39e658-5ec7-4156-a492-736c49849061",
      "clientId": "consectus-api",
      "token": self.token,
      "url": url
    }
    return new Promise(function (resolve, reject) {
      // if (self.platform.is('android') || self.platform.is('ios') || self.platform.is('cordova')) {
      //   self.sql_db = window.sqlitePlugin.openDatabase({ name: 'consectus.db', location: 'default' });
      //   self.sql_db.transaction(function (transaction) {
      //     transaction.executeSql("SELECT uuid FROM tbl_new_accounts LIMIT 1", [], function (tx, select_result) {
      //       let db_uuid = select_result.rows.item(0) ? select_result.rows.item(0).uuid : "";
      //       req_body.uuid = db_uuid;
      //       let headers = new Headers();
      //       headers.append('Content-Type', 'application/json');
      //       headers.append('Access-Control-Allow-Origin', self.global.getBaseUrl());
      //       headers.append('Origin', self.global.getBaseUrl());
      //       self.http.post(self.global.getBaseUrl() + "/oauth2/validate_token", req_body, { headers: headers })
      //         .map(res => res.json())
      //         .pipe(
      //           timeout(self.global.ajaxTimeout),
      //           catchError(e => {
      //             self.hideLoading();
      //             throw e;
      //           })
      //         )
      //         .subscribe(res => {
      //           self.hideLoading();
      //           if (res.status) {
      //             resolve(true)
      //           }
      //           else {
      //             self.token = res.token;
      //             self.expires_in = new Date(new Date().getTime() + (res.expires) * 1000);
      //             if (self.platform.is('android') || self.platform.is('ios') || self.platform.is('cordova')) {
      //               self.sql_db = window.sqlitePlugin.openDatabase({ name: 'consectus.db', location: 'default' });
      //               self.sql_db.transaction(function (delete_transaction) {
      //                 delete_transaction.executeSql('DELETE FROM tbl_oauth', [],
      //                   function (tx1, result) {
      //                     self.sql_db.transaction(function (insert_transaction) {
      //                       insert_transaction.executeSql("INSERT INTO tbl_oauth (token,expires) VALUES (?,?)", [res.access_token, self.expires_in], function (tx2, result2) {
      //                         if (res.type == "new") {
      //                           self.events.publish("consectus:cleardata");
      //                         }
      //                         else {
      //                           resolve(true);
      //                         }
      //                       },
      //                         function (insert_error) {
      //                           reject(insert_error);
      //                         });
      //                     });
      //                   },
      //                   function (create_error) {
      //                     reject(create_error);
      //                   });
      //               });
      //             }
      //             else {
      //               resolve(true);
      //             }
      //           }
      //         }, error => {
      //           self.hideLoading();
      //           reject(false)
      //         });
      //     },
      //       function (transaction_err) {
      //         self.hideLoading();
      //         reject(transaction_err)
      //       }
      //     );
      //   });
      // }
      // else {
      resolve(true);
      // }
    })
  }

  async sendUserOtp(otpData) {
    let self = this;
    let url = "/register/registernewonlinecustomer";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, otpData, true)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  async validateUserOtp(otpData) {
    let self = this;
    let url = "/register/registernewonlinecustomerotp";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, otpData, true)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }
  async newcustomerResidency(otpData) {
    let self = this;
    let url = "/register/registernewonlinecustomeraccounttype";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, otpData, true)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }
  async newcustomerTnc(otpData) {
    let self = this;
    let url = "/register/registernewonlinecustomertnc";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, otpData, true)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  async newcustomerSelectedProduct(otpData) {
    let self = this;
    let url = "/register/newonlinecustomerselectedProduct";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, otpData, true)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  async regularfrequency(otpData) {
    let self = this;
    let url = "/register/newonlinecustomerregularfrequency";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, otpData, true)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  async fundsOrigin(otpData) {
    let self = this;
    let url = "/register/newonlinecustomeroriginoffunds";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, otpData, true)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }
  async personalDetails(otpData) {
    let self = this;
    let url = "/register/newonlinecustomerpersonaldetails";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, otpData, true)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }
  async addressDetails(otpData) {
    let self = this;
    let url = "/register/newonlinecustomeraddressdetails";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, otpData, true)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }
  async nbaDetails(otpData) {
    let self = this;
    let url = "/register/newonlinecustomernbadetails";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, otpData, true)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }
  async istaxresident(otpData) {
    let self = this;
    let url = "/register/newonlinecustomertaxresident";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, otpData, true)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }
  async newccountregister(otpData) {
    let self = this;
    let url = "/accounts/newaccountregister";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, otpData, true)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  /**
   * update NBA Details
   */

  updatenbadetails(data) {
    let self = this;
    let url = '/accounts/updatenominatedbankdetails';
    return new Promise((resolve, reject) => {
      self.call_post(url, data)
        .then((result) => {
          resolve(result);
        }).catch((err) => {
          reject(err);
        })
    });
  }
  downloadperiodicstatements(data) {
    let self = this;
    let url = '/accounts/getaccountstatement';
    return new Promise((resolve, reject) => {
      self.call_post(url, data)
        .then((result) => {
          resolve(result);
        }).catch((err) => {
          reject(err);
        })
    });
  }

  getmortgageaccountstatement(data) {
    let self = this;
    let url = '/accounts/getmortgageaccountstatement';
    return new Promise((resolve, reject) => {
      self.call_post(url, data)
        .then((result) => {
          resolve(result);
        }).catch((err) => {
          reject(err);
        })
    });
  }

  async juniorcreatenewsavingaccount(formdata) {
    let self = this;
    let url = "/accounts/juniorcreatenewsavingaccount";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, formdata, true)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  // Online Login Api//
  webloginapi(body) {
    let self = this;
    let url = "/accounts/onlineloginv2";
    return new Promise(function (resolve, reject) {
      self.call_post(url, body)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }
  // Online user verification//
  webuserverification(body) {
    let self = this;
    let url = "/register/registernewonlinecustomer";
    return new Promise(function (resolve, reject) {
      self.call_post(url, body)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }
  // Online mobile ft verification//
  webusermobverification(body) {
    let self = this;
    let url = "/register/registeronlinefromapp";
    return new Promise(function (resolve, reject) {
      self.call_post(url, body)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }
  // Online mobile otp verification//
  webusermobotpverification(body) {
    let self = this;
    let url = "/register/verifyappotp";
    return new Promise(function (resolve, reject) {
      self.call_post(url, body)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }
  // Online send email otp//
  emailpasscode(body) {
    let self = this;
    let url = "/accounts/sendemailpasscode";
    return new Promise(function (resolve, reject) {
      self.call_post(url, body)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }
  // Online  update user id//
  emailasuserid(body) {
    let self = this;
    let url = "/accounts/verifyonlinepasscode";
    return new Promise(function (resolve, reject) {
      self.call_post(url, body)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }
  //////passbookcustomer register online/////
  passbookusercustomeronline(registerData) {
    let self = this;
    let url = registerData.is_forgotpin ? "/register/onlineforgotpassword" : "/register/passbookregistration";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, registerData, true)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }
  /////send two factor code////
  twofactorauth(data) {
    let self = this;
    let url = '/accounts/twofactorauth';
    return new Promise((resolve, reject) => {
      // bubbleError=true: bypass global 500 error screen, reject to parent
      // so the login page can show the api message.
      self.call_post(url, data, false, false, 1, true, true)
        .then((result) => {
          resolve(result);
        }).catch((err) => {
          reject(err);
        })
    });
  }
  //// verify two factor code
  verifytwofactor(data) {
    let self = this;
    let url = '/accounts/verifytwofactor';
    return new Promise((resolve, reject) => {
      self.call_post(url, data)
        .then((result) => {
          resolve(result);
        }).catch((err) => {
          reject(err);
        })
    });
  }
  ///// Online NCAO mobile verification//
  WebuserRegisternewonlinedevice(body) {
    let self = this;
    let url = "/register/registernewonlinedevice";
    return new Promise(function (resolve, reject) {
      self.call_post(url, body)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }
  /////online Send passcode for NCAO customer//
  SendpasscodetoRegisternewonlinedevice(body) {
    let self = this;
    let url = "/register/sendpasscodeverification";
    return new Promise(function (resolve, reject) {
      self.call_post(url, body)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }
  /////online verify passcode for NCAO customer//
  Verifypasscodefornewregisteronlinedevice(body) {
    let self = this;
    let url = "/register/verifyregpasscode";
    return new Promise(function (resolve, reject) {
      self.call_post(url, body)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }
  /////////////////verify unique Security Code for online///////////////////////
  verifyuniqueSecurityCode(newaccount) {
    let self = this;
    let url = "/accounts/verifyonlinesecuritycode";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, newaccount, true)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  get_smartSearch_DocData(data) {
    let self = this;
    let url = '/accounts/smartsearchretrievedoc';
    return new Promise((resolve, reject) => {
      self.call_post(url, data)
        .then((result) => {
          resolve(result);
        }).catch((err) => {
          reject(err);
        })
    });
  }

  smartSearch_CheckDoc(data) {
    let self = this;
    let url = '/accounts/smartsearchdocumentcheck';
    return new Promise((resolve, reject) => {
      self.call_post(url, data)
        .then((result) => {
          resolve(result);
        }).catch((err) => {
          reject(err);
        })
    })
  }


  /** Get online setting from online customer **/
  getSettingsOnline(custormer_id) {
    let self = this;
    let url = '/accounts/getcustomerbycustomeridonline';
    self.flag = 1;
    return new Promise(function (resolve, reject) {
      self.call_post(url, custormer_id)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    })
  }

  // verify xid
  verifyXID(body: any): Promise<any> {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.call_post('/register/verifymigrationlink', body)
        .then((data: any) => resolve(data))
        .catch((err: any) => reject(err));
    });
  }

  // Send Passcode
  sendPassCode(body: any): Promise<any> {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.call_post('/register/sendverificationpasscode', body)
        .then((data: any) => resolve(data))
        .catch((err: any) => reject(err));
    });
  }

  // Verify Pass
  verifyPassCode(body: any): Promise<any> {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.call_post('/register/verifymigrationpasscode', body)
        .then((data: any) => resolve(data))
        .catch((err: any) => reject(err));
    });
  }
  //+++++++++ Save Application Status Online ++++++++++//
  SaveApplicationStatusOnline(data) {
    let self = this;
    let url = '/register/saveprogress';
    return new Promise((resolve, reject) => {
      self.call_post(url, data)
        .then((result) => {
          resolve(result);
        }).catch((err) => {
          reject(err);
        })
    });
  }
  //+++++++++ Saved Application Number Verification Online ++++++++++//
  SavedApplicationNumberVerificationOnline(data) {
    let self = this;
    let url = '/register/retriveprogress';
    return new Promise((resolve, reject) => {
      self.call_post(url, data)
        .then((result) => {
          resolve(result);
        }).catch((err) => {
          reject(err);
        })
    });
  }

  SearchCustomer(data: any) {
    let self = this;
    let url = '/accounts/searchexistingcustomer';
    return new Promise((resolve, reject) => {
      self.call_post(url, data)
        .then((result) => {
          resolve(result);
        }).catch((err) => {
          reject(err);
        })
    });
  }

  UpdateNINumber(data: any) {
    let self = this;
    let url = '/accounts/updateninumbers';
    return new Promise((resolve, reject) => {
      self.call_post(url, data)
        .then((result) => {
          resolve(result);
        }).catch((err) => {
          reject(err);
        })
    });
  }

  UpdateProfile(data: any) {
    let self = this;
    let url = '/accounts/updateninumbers';
    return new Promise((resolve, reject) => {
      self.call_post(url, data)
        .then((result) => {
          resolve(result);
        }).catch((err) => {
          reject(err);
        })
    });
  }
  //<<<--------====<<(For Update PhoneNumber or Email Address.)>>====------->>>//
  UpdateEmailAndPhonenumber(data: any) {
    let self = this;
    let url = '/accounts/updateemailandphone';
    return new Promise((resolve, reject) => {
      self.call_post(url, data)
        .then((result) => {
          resolve(result);
        }).catch((err) => {
          reject(err);
        })
    });
  }
  //<<<--------====<<(For send otp on PhoneNumber or Email Address.)>>====------->>>//
  SendOtpOnPhoneOrEmail(data: any) {
    let self = this;
    let url = '/accounts/sendupdateotp';
    return new Promise((resolve, reject) => {
      self.call_post(url, data)
        .then((result) => {
          resolve(result);
        }).catch((err) => {
          reject(err);
        })
    });
  }
  //<<<--------====<<(For Update Address Details.)>>====------->>>//
  UpdateAddressDetails(data: any) {
    let self = this;
    let url = '/accounts/updatecustomeraddress';
    return new Promise((resolve, reject) => {
      self.call_post(url, data)
        .then((result) => {
          resolve(result);
        }).catch((err) => {
          reject(err);
        })
    });
  }

  // (For gettingNba details for transfers)

  getNbaDetailsByAccount(customer_id, accountno) {
    let self = this;
    let data = {
      "customers_id": customer_id,
      "accountno": accountno
    }
    let url = '/accounts/getnbadetailsbyaccount';
    return new Promise(function (resolve, reject) {
      self.call_post(url, data)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    })
  }
  /** <----------Get All Online Labels----------> **/

  gateway

  /**
  
   * Get labels
  
   * @returns
  
   */

  getlabels() {
    let self = this;
    let url = '/register/getlabelsjson';
    return new Promise((resolve, reject) => {
      self.call_get(url)
        .then((result) => {
          resolve(result);
        }).catch((err) => {
          reject(err);
        })
    });
  }
  /**
   * Change online customer status
   * @param deviceData 
   */
  changeOnlineCustomerStatus(deviceData) {
    let self = this;
    let url = "/register/updatestatestatus";
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post(url, deviceData, true)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }
  private enqueueRequest<T>(fn: () => Promise<T>): Promise<T> {
    this.requestQueue = this.requestQueue
      .then(() => fn())
      .catch((e) => {
        this.requestQueue = Promise.resolve();
        throw e;
      });
    return this.requestQueue;
  }
  downloadstatementv2(url: string) {
    return this.enqueueRequest(() => {
      let self = this;

      return new Promise((resolve, reject) => {
        self.getAccessToken().then(async (result_data: any) => {
          const headers = new Headers();
          headers.append('Authorization', 'Bearer ' + self.token);
          headers.append('Content-Type', 'application/json');

          const options = new RequestOptions({
            headers: headers,
            responseType: ResponseContentType.Blob,
          });

          await this.http.get(self.global.getBaseUrl() + url, options)
            .toPromise()
            .then((response: any) => {
              const blob = response._body;
              const filename = `StepOne-${Date.now()}.pdf`;
              const link = document.createElement('a');
              const objectUrl = URL.createObjectURL(blob);

              link.href = objectUrl;
              link.setAttribute('download', filename);
              link.style.display = 'none';
              document.body.appendChild(link);
              link.click();

              setTimeout(() => {
                URL.revokeObjectURL(objectUrl);
                document.body.removeChild(link);
                resolve(true);
              }, 2000);
            })
            .catch(error => {
              console.error('Download failed:', error);
              resolve(false);
            });
        });
      });
    });
  }

  downloadDocument(url: string, data: any): Promise<any> {
    const self = this;
    const headers = new Headers();
    headers.append('Authorization', 'Bearer ' + self.token);
    headers.append('Content-Type', 'application/json');

    return new Promise((resolve, reject) => {
      self.http.post(self.global.getBaseUrl() + url, data, { headers: headers })
        .map(res => res.json())
        .pipe(
          timeout(self.global.ajaxTimeout),
          catchError(e => { throw e; })
        )
        .subscribe(data => { resolve(data); }, error => { reject(error); });
    });
  }

  getRedemptionData(accountNumber: string) {
    let self = this;
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post("/accounts/redemption", { "account_number": accountNumber })
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  getrequestredemptionstatement(accountNumber: string) {
    let self = this;
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post("/accounts/requestredemptionstatement", { "account_number": accountNumber })
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  paymentvalidation(data: any) {
    let self = this;
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post("/accounts/paymentvalidation", data)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  getpaymentlink(data: any) {
    let self = this;
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post("/accounts/paymentlink", data)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

  checkpayment(data: any) {
    let self = this;
    self.flag = 0;
    return new Promise(function (resolve, reject) {
      self.call_post("/accounts/checkpayment", data)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    });
  }

}


// WEBPACK FOOTER //
// ./src/providers/gateway-client/gateway-client.ts